(function(){
    const UA = navigator.userAgent.toLowerCase();
    if (UA.includes('googlebot')) return;

    async function getCountry(){
        const RESPONSE = await fetch('/browsing_context_suggestions.json');
        const GET_COUNTRY = await RESPONSE.json();

        return GET_COUNTRY;
    }

    async function redirection(){
        const COUNTRIES_LIST_code = ["FR", "BE", "CH"];
        const CURRENT_URL = window.location.href;
        getCountry().then(function(data) {
            const country_code = data.detected_values.country.handle;
            const is_redirected = JSON.parse(localStorage.getItem('is_redirected'));
            if(!is_redirected){
                localStorage.setItem('is_redirected', true);
                if(COUNTRIES_LIST_code.includes(country_code.toUpperCase())){
                    if(CURRENT_URL.indexOf(".com/en") > -1){
                        window.stop()
                        window.location.href= "/";
                    }
                }
                else{
                    if(CURRENT_URL.indexOf(".com/en") == -1){
                        window.stop();
                        window.location.href= "/en"
                    }
                }
            }
        });
    }

    window.onload = redirection();    

})();
